/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Compare_Workflow_GcInputs */

const en_gc_resources_compare_workflow_gc = /** @type {(inputs: Gc_Resources_Compare_Workflow_GcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Local XLSX files and local calculation`)
};

const zh_gc_resources_compare_workflow_gc = /** @type {(inputs: Gc_Resources_Compare_Workflow_GcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本地 XLSX 文件与本地计算`)
};

/**
* | output |
* | --- |
* | "Local XLSX files and local calculation" |
*
* @param {Gc_Resources_Compare_Workflow_GcInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_compare_workflow_gc = /** @type {((inputs?: Gc_Resources_Compare_Workflow_GcInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Compare_Workflow_GcInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_compare_workflow_gc(inputs)
	return zh_gc_resources_compare_workflow_gc(inputs)
});
export { gc_resources_compare_workflow_gc as "gc.resources.compare.workflow.gc" }